import React, { useState } from "react";
import Modal from "../Modal";
import { useDispatch } from "react-redux";
import { addFAQ, getFAQ } from "../../features/slices/faqManagement";
import { toastService } from "../../utils/toastify";
const initialState = {
  question: "",
  answer: "",
};
const AddFAQ = ({ setUpdateState }) => {
  const [iState, setIState] = useState(initialState);
  const [errors, setErrors] = useState({});
  const { question, answer } = iState;
  const disptach = useDispatch();
  const handleClose = () => {
    setUpdateState((prev) => ({ ...prev, showAddFaq: false }));
  };
  const handleChange = (e) => {
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
    const { name, value } = e.target;
    setIState((prev) => ({ ...prev, [name]: value }));
  };
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!question?.trim()) {
      formErrors.question = "question is required.";
      isValid = false;
    }
    if (!answer?.trim()) {
      formErrors.answer = "answer is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };
  const handleAddFAQ = (e) => {
    if (validateForm()) {
      disptach(addFAQ(iState)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Faq added successfully");
          disptach(getFAQ());
          handleClose();
        } else {
          toastService.error(res?.payload?.message);
        }
      });
    }
  };

  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Add Faq</h3>
          <div className="form-group">
            <label>Faq Question</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Faq Question"
              name="question"
              onChange={handleChange}
              value={question}
            />
            {errors.question && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.question}
              </p>
            )}
          </div>
          <div className="form-group">
            <label>Faq Answer</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Faq Answer"
              name="answer"
              onChange={handleChange}
              value={answer}
            />
            {errors.answer && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.answer}
              </p>
            )}
          </div>

          <div className="Buttons">
            <button className="Button ml-0" onClick={handleAddFAQ}>
              Add Faq
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddFAQ;
